export const ViewOpportunityHistoryGridConfig = 
    { styleSingle: { maxHeight: 'calc(50vh)' }, styleDouble: { maxHeight: 'calc(25vh)' }, styleTriple: { maxHeight: 'calc(15vh)' }, 
    showBorders: true, showColumnLines: true, columnAutoWidth: true, gridKeyExpr: 'id', allowColumnReordering: true, 
    allowColumnResizing: true, columnResizingMode: 'widget', columnMinWidth:100 };